angular.module('clients')
    .component('clientCompactPreview', {
        bindings: {
            item: '<',
            options: '<?'
        },
        template: `
            <div class="client-compact-preview" ng-if="$ctrl.item" ng-class="{'client-compact-preview--compact': $ctrl.options.compact === true}">
                <div class="client-compact-preview__header">
                    <div class="client-compact-preview__avatar">
                        <i class="fa fa-fw" ng-class="$ctrl.item.leadOnly ? 'fa-user-o' : 'fa-building-o'"></i>
                    </div>
                    <div class="client-compact-preview__identity">
                        <div class="client-compact-preview__name">
                            <a ng-if="$ctrl.item.id && $ctrl.options.link !== false" ui-sref="clientShow({id: $ctrl.item.id})">{{$ctrl.item.fullName || $ctrl.firstContactValue($ctrl.item) || '-'}}</a>
                            <span ng-if="!$ctrl.item.id || $ctrl.options.link === false">{{$ctrl.item.fullName || $ctrl.firstContactValue($ctrl.item) || '-'}}</span>
                        </div>
                        <div class="client-compact-preview__subtitle">
                            <span ng-if="$ctrl.item.symbol">{{$ctrl.item.symbol}}</span>
                            <span ng-if="$ctrl.item.leadOnly">kontrahent leada</span>
                            <span ng-if="$ctrl.item.type">{{('client.type.' + $ctrl.item.type) | translate}}</span>
                        </div>
                    </div>
                    <client-status-label ng-if="$ctrl.options.showStatus === true && $ctrl.item.status"
                                         status="$ctrl.item.status"></client-status-label>
                </div>

                <div class="client-compact-preview__section" ng-if="$ctrl.sortedContacts($ctrl.item).length > 0">
                    <div class="client-compact-preview__details">
                        <div class="client-compact-preview__detail client-compact-preview__detail--contacts">
                            <span>Kontakty</span>
                            <div class="client-show-contact-list client-show-contact-list--compact">
                                <div class="client-show-contact-list__item" ng-repeat="c in $ctrl.sortedContacts($ctrl.item) track by (c.id || $index)">
                                    <div class="client-show-contact-list__icon">
                                        <span class="contact-type-badge"
                                              ng-class="'contact-type-badge--' + (c.type || 'OTHER')"
                                              uib-tooltip="{{('contact.type.' + (c.type || 'OTHER')) | translate}}"
                                              tooltip-placement="top">
                                            <i class="fa fa-fw contact-type-icon" ng-class="'contact-type-icon--' + (c.type || 'OTHER')"></i>
                                        </span>
                                    </div>
                                    <div class="client-show-contact-list__body">
                                        <div class="client-show-contact-list__value">
                                            <phone-number-display ng-if="c.type === 'PHONE'" value="c.value" subject-name="c.name || $ctrl.item.fullName" show-options-menu="false"></phone-number-display>
                                            <email-display ng-if="c.type === 'EMAIL'" value="c.value"></email-display>
                                            <a ng-if="c.type === 'WEBSITE'" ng-href="{{$ctrl.normalizeWebsiteUrl(c.value)}}" target="_blank">{{c.value}}</a>
                                            <span ng-if="c.type !== 'PHONE' && c.type !== 'EMAIL' && c.type !== 'WEBSITE'">{{c.value}}</span>
                                        </div>
                                        <div class="client-show-contact-list__meta" ng-if="c.name || c.defaults || c.active === false">
                                            <span ng-if="c.name">{{c.name}}</span>
                                            <span ng-if="c.defaults">domyślny</span>
                                            <span ng-if="c.active === false" class="text-danger">nieaktywny</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="client-compact-preview__section" ng-if="$ctrl.hasAddress($ctrl.item) || $ctrl.item.nip || $ctrl.item.regon">
                    <div class="client-compact-preview__details">
                        <div class="client-compact-preview__detail" ng-if="$ctrl.hasAddress($ctrl.item)">
                            <span>Adres</span>
                            <strong>{{$ctrl.address($ctrl.item)}}</strong>
                        </div>
                        <div class="client-compact-preview__detail" ng-if="$ctrl.item.nip">
                            <span>NIP</span>
                            <strong>{{$ctrl.item.nip}}</strong>
                        </div>
                        <div class="client-compact-preview__detail" ng-if="$ctrl.item.regon">
                            <span>REGON</span>
                            <strong>{{$ctrl.item.regon}}</strong>
                        </div>
                    </div>
                </div>

                <div class="client-compact-preview__section" ng-if="$ctrl.options.showManager !== false && $ctrl.item.managerUsers && $ctrl.item.managerUsers.length">
                    <div class="client-compact-preview__details">
                        <div class="client-compact-preview__detail client-compact-preview__detail--managers">
                            <span>Opiekunowie</span>
                            <div class="lead-preview-assignment-worker client-compact-preview__managers">
                                <span class="lead-preview-assignment-worker-main" ng-repeat="manager in ($ctrl.item.managerUsers | orderBy:'lastName') track by manager.id">
                                    <user-avatar user="manager"></user-avatar>
                                    <span class="lead-preview-assignment-worker-name">{{manager.fullName}}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `,
        controller: function () {
            const ctrl = this;
            const defaultOptions = {
                compact: false,
                link: true,
                showManager: true,
                showStatus: false,
                showPhone: true,
                showEmail: true
            };

            ctrl.$onInit = () => {
                ctrl.options = angular.extend({}, defaultOptions, ctrl.options);
            };

            ctrl.$onChanges = () => {
                ctrl.options = angular.extend({}, defaultOptions, ctrl.options);
            };

            ctrl.sortedContacts = client => sortContacts((client && client.contacts) || [])
                .filter(contact => isContactVisible(contact, ctrl.options));

            ctrl.firstContactValue = client => {
                const contact = ctrl.sortedContacts(client).find(item => item && item.value);
                return contact ? contact.value : null;
            };

            ctrl.normalizeWebsiteUrl = value => {
                if (!value) {
                    return null;
                }
                return /^https?:\/\//i.test(value) ? value : 'http://' + value;
            };

            ctrl.hasAddress = client => !!(client && (client.fullAddress || client.address || client.postcode || client.city));

            ctrl.address = client => {
                if (!client) {
                    return null;
                }
                if (client.fullAddress) {
                    return client.fullAddress;
                }
                return [
                    client.address,
                    [client.postcode, client.city].filter(Boolean).join(' ')
                ].filter(Boolean).join(', ');
            };

            function sortContacts(contacts) {
                const order = {PHONE: 1, EMAIL: 2, WEBSITE: 3, OTHER: 4};
                return (contacts || [])
                    .filter(contact => contact && contact.value)
                    .slice()
                    .sort((a, b) => {
                        const typeCompare = (order[a.type] || 9) - (order[b.type] || 9);
                        if (typeCompare !== 0) {
                            return typeCompare;
                        }
                        return (a.id || 0) - (b.id || 0);
                    });
            }

            function isContactVisible(contact, options) {
                if (!contact || !contact.value) {
                    return false;
                }
                if (contact.type === 'PHONE') {
                    return options.showPhone !== false;
                }
                if (contact.type === 'EMAIL') {
                    return options.showEmail !== false;
                }
                return true;
            }
        }
    })
